<div class="header">
  <div class="header__container">
    <div class="header__organization">
      {{ userSignal()?.organizationName ?? [] | displayLocale: null : 'label' }}
    </div>
    <dsy-heading level="h4" level-size="2xl" level-style="bold">
      {{ 'FLEX_HOME.HOME.TITLE' | translate }}{{ userSignal()?.firstName ? ', ' + userSignal()?.firstName : '' }}
    </dsy-heading>
    <dr-flex-home-ui-header-most-visited [hasCOM]="hasCOMSignal()"></dr-flex-home-ui-header-most-visited>
  </div>
</div>
<section class="cta-notification-section">
  <dr-flex-home-ui-notification-banner></dr-flex-home-ui-notification-banner>
</section>
<section class="dashboard-section">
  <dr-flex-home-ui-widget-layout class="child"></dr-flex-home-ui-widget-layout>
</section>
